import React from "react";
import classes from "./Footer.module.scss";
export const Footer = () => {
  return (
    <footer>
      <ul className={classes.footerRoot}>
        <a
          className={classes.text}
          href="https://www.morimatsu.jp/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <li>運営会社</li>
        </a>
        <a className={classes.text} href="/menulist" rel="noreferrer noopener">
          <li>利用規約</li>
        </a>
        <a className={classes.text} href="/menulist" rel="noreferrer noopener">
          <li>プライバシーポリシー</li>
        </a>
        <a className={classes.text}>
          <li>Copyright &copy; 2024 MORIMATSU INDUSTRY CO.,LTD</li>
        </a>
      </ul>
    </footer>
  );
};
